import script from "./ApolloDebugWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ApolloDebugWidget.vue?vue&type=script&setup=true&lang=js"

import "./ApolloDebugWidget.vue?vue&type=style&index=0&id=0be59512&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be59512"]])

export default __exports__